import { getRequestPayment } from "../../http/HttpRequest";
import { RequestPaymentData } from "./types";

export const createPayment = async (
  amount: number,
  appointmentId: string,
  email: string
) => {
  try {
    const reqData: RequestPaymentData = {
      amount: amount,
      appointmentId: appointmentId,
      email: email,
    };

    const response = await getRequestPayment("createPayment", reqData);

    return response.data.redirect;
  } catch (e) {
    return undefined;
  }
};
